import { Pipe, PipeTransform } from "@angular/core";
import { formatIndianCurrency } from "../CustomFunctions/CustomFunctions";

@Pipe({
    name: 'indianCurrency'
})

export class IndianCurrencyPipe implements PipeTransform {
    transform(value: number): string {
        return formatIndianCurrency(value);
    }
    
}